<section class="app-ded-tra" [id]="BrandSection.DEDICATED">
  <div class="container app-ded-tra__con">
    <h6 class="app-ded-tra__con__h6" [appAnimate]="'landing'" [speed]="'fast'" [aos]="0.4">
      Sprawdź pozostałe dedykowane szkolenia naszych marek
    </h6>
    <p class="app-ded-tra__con__p" [appAnimate]="'landing'" [speed]="'fast'" [aos]="0.4">
      Kliknij na logotyp marki, aby przejść na odpowiednią stronę:
    </p>
    <ul class="list-unstyled app-ded-tra__con__ul">
      <li class="app-ded-tra__con__ul__li" [appAnimate]="'landing'" [speed]="'fast'" [aos]="0.5">
        <a
          class="app-ded-tra__con__ul__li__a"
          [routerLink]="['/' + WwwRouteSlug.BRAND, Brand.KERASTASE]"
          appGtmClick
          [layer]="{
            event: 'uaevent',
            ecommerce: 'undefined',
            eventCategory: 'brand dedicated trainings page',
            eventAction: 'select::go to brand kerastase',
            eventLabel: 'go to brand kerastase::' + '/' + WwwRouteSlug.BRAND + Brand.KERASTASE,
            event_name: 'body_button_click',
            module_name: 'go to brand kerastase',
            cta_name: 'go to brand kerastase',
            link_url: '/' + WwwRouteSlug.BRAND + Brand.KERASTASE,
          }"
        >
          <img
            class="app-ded-tra__con__ul__li__a__img"
            [priority]="false"
            alt="kerastase"
            ngSrc="assets/images/kerastase.svg"
            width="121"
            height="34"
            [appAnimate]="'fadeIn'"
            [speed]="'fast'"
        /></a>
      </li>
      <li class="app-ded-tra__con__ul__li" [appAnimate]="'landing'" [speed]="'fast'" [aos]="0.5" [delay]="'200'">
        <a
          class="app-ded-tra__con__ul__li__a"
          [routerLink]="['/' + WwwRouteSlug.BRAND, Brand.LOREAL_PROFESSIONNEL]"
          appGtmClick
          [layer]="{
            event: 'uaevent',
            ecommerce: 'undefined',
            eventCategory: 'brand dedicated trainings page',
            eventAction: 'select::go to brand loreal',
            eventLabel: 'go to brand loreal::' + '/' + WwwRouteSlug.BRAND + Brand.LOREAL_PROFESSIONNEL,
            event_name: 'body_button_click',
            module_name: 'go to brand loreal',
            cta_name: 'go to brand loreal',
            link_url: '/' + WwwRouteSlug.BRAND + Brand.LOREAL_PROFESSIONNEL,
          }"
        >
          <img
            class="app-ded-tra__con__ul__li__a__img"
            [priority]="false"
            alt="loreal"
            ngSrc="assets/images/loreal.png"
            width="145"
            height="51"
            [appAnimate]="'fadeIn'"
            [speed]="'fast'"
          />
        </a>
      </li>
      <li class="app-ded-tra__con__ul__li" [appAnimate]="'landing'" [speed]="'fast'" [aos]="0.5" [delay]="'400'">
        <a
          class="app-ded-tra__con__ul__li__a"
          [routerLink]="['/' + WwwRouteSlug.BRAND, Brand.REDKEN]"
          appGtmClick
          [layer]="{
            event: 'uaevent',
            ecommerce: 'undefined',
            eventCategory: 'brand dedicated trainings page',
            eventAction: 'select::go to brand redken',
            eventLabel: 'go to brand redken::' + '/' + WwwRouteSlug.BRAND + Brand.REDKEN,
            event_name: 'body_button_click',
            module_name: 'go to brand redken',
            cta_name: 'go to brand redken',
            link_url: '/' + WwwRouteSlug.BRAND + Brand.REDKEN,
          }"
        >
          <img
            class="app-ded-tra__con__ul__li__a__img"
            [priority]="false"
            alt="redken"
            ngSrc="assets/images/redken.svg"
            width="137"
            height="36"
            [appAnimate]="'fadeIn'"
            [speed]="'fast'"
          />
        </a>
      </li>
    </ul>
  </div>
</section>
